/* istanbul ignore file */

import { ProjectFieldGroup, SelectableField } from '../../../models';

export class SelectableFieldsServiceModel {
    selectableFields: SelectableField[] = [];
    selectableFieldsLoading = false;
    associatedProjectId: string | null;
    projectFieldGroups: ProjectFieldGroup[] = [];
    projectFieldGroupsLoading = false;
    selectableFieldsByHash = new Map<string, SelectableField>();
    projectNamesByHash = new Map<string, string>();
    selectableFieldsByProjectAndId = new Map<string, SelectableField>();
    projectNamesById = new Map<string, string>();
    projectIdsByHash = new Map<string, string>();
    fieldOriginsById = new Map<string, { projectId: string | undefined; selectableField: SelectableField; }>();

    constructor() {
        this.associatedProjectId = null;
    }
}
